<template>
    <div class="shadow-md rounded-md p-3 lg:p-6 bg-white">
        <slot />
    </div>
</template>
